import { render, staticRenderFns } from "./AppTeamList.vue?vue&type=template&id=8134d7f6"
import script from "./AppTeamList.vue?vue&type=script&lang=js"
export * from "./AppTeamList.vue?vue&type=script&lang=js"
import style0 from "./AppTeamList.vue?vue&type=style&index=0&id=8134d7f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports